import { InnerContentItem } from "@certn/cascadia-react";
import { CascadiaControlProps } from "@certn/forms";
import { truncatedFileName } from "@certn/utils";

import { tryOpenDocumentInNewTab } from "./utils";
import { useApplicationFormContext } from "../../ApplicationFormContext";
import { dataToFile } from "../../utils";

export function UploadSummaryControl(props: CascadiaControlProps) {
  const { data, label, uischema } = props;
  const options = uischema.options || {};
  const { downloadUrl } = useApplicationFormContext();
  const itemSubtitle = options.itemSubtitle || undefined;

  const files = Array.isArray(data)
    ? data.map((file) => {
        return dataToFile(file, itemSubtitle);
      })
    : [dataToFile(data, itemSubtitle)];

  return (
    <>
      {files.map((file, index) => {
        if (!file) return null;
        const [start, end] = truncatedFileName(file.name || "");
        return (
          <InnerContentItem
            key={index}
            label={label}
            testID="download-file-link"
            icon="download"
            onIconPress={() => {
              tryOpenDocumentInNewTab(downloadUrl, file.key);
            }}
          >
            {start}
            {end}
          </InnerContentItem>
        );
      })}
    </>
  );
}
